import * as FuseModule from 'fuse.js';
import { CarePlanOptionTitle } from './options.model';

const OPTION_TITLE_RESULT_LIMIT = 20;
type FuseConstructor = typeof import('fuse.js').default;
const Fuse = ((FuseModule as unknown as { default?: FuseConstructor })
  .default ?? FuseModule) as FuseConstructor;

export function searchOptionTitles(
  titles: readonly CarePlanOptionTitle[],
  query: string,
): CarePlanOptionTitle[] {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return titles.slice(0, OPTION_TITLE_RESULT_LIMIT);

  const exact = titles.filter((item) =>
    item.title.toLowerCase().includes(normalized),
  );
  if (normalized.length < 2) {
    return exact.slice(0, OPTION_TITLE_RESULT_LIMIT);
  }

  const exactIds = new Set(exact.map((item) => item.id));
  const fuzzy = new Fuse([...titles], {
    keys: ['title'],
    threshold: 0.3,
    ignoreLocation: true,
    minMatchCharLength: 2,
    useTokenSearch: true,
  })
    .search(normalized, { limit: OPTION_TITLE_RESULT_LIMIT })
    .map((result) => result.item)
    .filter((item) => !exactIds.has(item.id));

  return [...exact, ...fuzzy].slice(0, OPTION_TITLE_RESULT_LIMIT);
}
